import type { PropsWithChildren, ReactNode } from "react";
import {
  Tooltip as ComponentTooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@shared-kernel/primary/shared/shadcn/ui/tooltip";
import type { LucideIcon } from "lucide-react";
import { HelpCircle } from "lucide-react";

interface Props {
  tooltipContent: ReactNode;
  icon?: LucideIcon;
  iconColor?: string;
  iconSize?: number;
}

export const Tooltip = ({
  tooltipContent,
  children,
  icon: Icon = HelpCircle,
  iconColor = "gray",
  iconSize = 14,
}: PropsWithChildren<Props>) => {
  return (
    <TooltipProvider>
      <ComponentTooltip>
        <TooltipTrigger asChild>
          <div className="flex">
            {children}
            <Icon size={iconSize} className="ml-1" color={iconColor} />
          </div>
        </TooltipTrigger>
        <TooltipContent>{tooltipContent}</TooltipContent>
      </ComponentTooltip>
    </TooltipProvider>
  );
};
